import React from 'react';
import { Target } from 'lucide-react';

function DailyTargetIncentiveCard({ data, handleInputChange }) {
  return (
    <div>
      <div className="bg-white border rounded-lg p-6">
        <div className="flex items-center mb-4">
          <div className="p-2 bg-blue-100 rounded-lg mr-3">
            <Target className="h-5 w-5 text-blue-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">Daily Target Incentive</h3>
        </div>

        <div className="space-y-4">
          {/* Status Toggle */}
          <div className="flex items-center justify-between">
            <label className="text-sm font-medium text-gray-700">Enable Daily Target Incentive</label>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={data.status}
                onChange={(e) => handleInputChange('dailyTragetIncentive', 'status', e.target.checked)}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
          </div>

          {/* Incentive Type */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Incentive Type
            </label>
            <select
              value={data.type}
              onChange={(e) => handleInputChange('dailyTragetIncentive', 'type', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              disabled={!data.status}
            >
              <option value="multiple">Multiple</option>
              <option value="fixed">Fixed</option>
              <option value="percentage">Percentage</option>
            </select>
          </div>

          {/* Multiple Of */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Multiple Of
            </label>
            <select
              value={data.of}
              onChange={(e) => handleInputChange('dailyTragetIncentive', 'of', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              disabled={!data.status}
            >
              <option value="salary">Salary</option>
              <option value="sale">Sale</option>
            </select>
          </div>

          {/* Target Value */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Target {data.type.charAt(0).toUpperCase() + data.type.slice(1)} {data.type === 'multiple' ? '(X)' : data.type === 'percentage' ? '(%)' : '(₹)'}
            </label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={data.targetValue}
              onChange={(e) => handleInputChange('dailyTragetIncentive', 'targetValue', parseFloat(e.target.value) || 0)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter target value"
              disabled={!data.status}
            />
          </div>

          {/* Max Incentive */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Max Incentive (₹)
            </label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={data.maxIncentive}
              onChange={(e) => handleInputChange('dailyTragetIncentive', 'maxIncentive', parseFloat(e.target.value) || 0)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter max incentive"
              disabled={!data.status}
            />
          </div>
        </div>
      </div>

      {/* Note and Calculation */}
      <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-800">
          <strong>Note:</strong> Daily incentive is calculated based on daily salary X target. 
          For example, if salary is ₹18,000, then daily calculation is: ₹18,000 ÷ 26 working days = ₹692/day X target
        </p>
        {data.status && (
          <div className="mt-3 p-2 bg-white border border-blue-300 rounded">
            <p className="text-sm text-gray-700">
              <strong>Working Calculation:</strong>
            </p>
            <p className="text-sm text-gray-600 mt-1">
              Base Salary: ₹18,000 ÷ 26 = ₹692/day
            </p>
            <p className="text-sm text-gray-600">
              Daily Incentive: ₹692 X {data.targetValue || 0} = ₹{(692 * (data.targetValue || 0)).toLocaleString()}
              {data.maxIncentive > 0 && (
                <span className="text-blue-600"> (Max: ₹{data.maxIncentive.toLocaleString()})</span>
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default DailyTargetIncentiveCard;